import {createUseStyles} from "react-jss";
import {SectionGridSize, VerticalAlign} from "../helpers/enums";
import {useBreakpoints} from "../layout/useBreakpoints";
import {useMediaQuery} from "../layout/useMediaQuery";
import {down} from "../layout/breakpoints";
import {useEffect, useState} from "react";
import {computeMapSectionMultiplier} from "../map/mapWaypoints";

const useStyles = createUseStyles({
    stickyWrapper: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        pointerEvents: "none",
        gridColumn: ({ startColumn, endColumn }) => `${startColumn} / ${endColumn}`,
        gridRow: ({ stepIndex }) => (stepIndex !== undefined ? `${stepIndex + 1} / ${stepIndex + 2}` : "auto"),
        justifyContent: ({verticalAlign}) => {
            if (verticalAlign === VerticalAlign.BOTTOM) {
                return "flex-end";
            } else if (verticalAlign === VerticalAlign.CENTER) {
                return "center";
            } else {
                return "flex-start";
            }
        },
    },
});

export const ScrollerWrapper = ({
    stepIndex,
    startColumn,
    endColumn,
    gridSize,
    verticalAlign,
    containersCount,
    isThumbnail,
    isMap=false,
    contentHeight,
    children
}) => {
    const [height, setHeight] = useState("100%")
    const breakpoints = useBreakpoints()
    const matchLargeDown = useMediaQuery(down(breakpoints.large))
    const is12Col = gridSize === SectionGridSize.TWELVE_COLUMNS || gridSize === "twelveColumns" || (endColumn && endColumn > 9);
    const computedStartColumn = matchLargeDown ? (is12Col ? 2 : 5) : startColumn;
    const computedEndColumn = matchLargeDown ? (is12Col ? 12 : 6) : endColumn;
    const classes = useStyles({
        verticalAlign: verticalAlign,
        startColumn: computedStartColumn,
        endColumn: computedEndColumn,
        stepIndex,
    })

    useEffect(
        () => {
            if(isThumbnail) {
                setHeight("100%")
            } else if(isMap) {
                const multiplier = computeMapSectionMultiplier(containersCount);
                setHeight(`${(multiplier * contentHeight) / (containersCount || 1)}px`);
            } else {
                setHeight(containersCount === 1 ? `${contentHeight}px` : `${contentHeight}px`)
            }
            return () => setHeight("100%")
        },
        [containersCount, isThumbnail, contentHeight, isMap]
    )

    return (
        <div
            className={classes.stickyWrapper}
            style={{
                height: height,
                minWidth: isThumbnail ? undefined : "min(320px, 88vw)",
                paddingTop: !isThumbnail && !isMap && containersCount === 1 ? `${contentHeight}px` : "0px",
                marginBottom: !isThumbnail && !isMap && containersCount > 1 ? `${Math.round((contentHeight || 800) * 0.45)}px` : "0px",
                boxSizing: "content-box",
                gridRow: stepIndex !== undefined ? `${stepIndex + 1} / ${stepIndex + 2}` : "auto",
            }}
        >
            {children}
        </div>
    )
}